import { render, staticRenderFns } from "./collaborators.vue?vue&type=template&id=00ffed2b"
import script from "./collaborators.ts?vue&type=script&lang=ts&external"
export * from "./collaborators.ts?vue&type=script&lang=ts&external"
import style0 from "./collaborators.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports